/**
 * 转换成合法的价格
 * @param {Number | String} value 价格
 * @param {Number} fixedNum 精度
 */
export const getValidPrice = (value, fixedNum = 2) => {
  const valNum = Number(value);
  if (!value || Number.isNaN(valNum)) {
    return '';
  }
  return valNum.toFixed(fixedNum);
};

/**
 * 根据币种格式化金额 3 USD -> $3.00
 * @param {String} money  金额
 * @param {String} currency  币种
 * @returns {String} 返回格式化后的字符串金额
 */
export const formatMoney = (money, currency) => {
  const formater = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  });
  return formater.format(money || 0);
};
